import { Team } from '../../../../../../types/sport';

export const LA_LIGA_TEAMS: Team[] = [
  {
    value: 'barcelona',
    label: 'Barcelona',
    players: [
      { value: 'dani olmo', label: 'Dani Olmo', country: 'espana' },
      { value: 'frenkie de jong', label: 'Frenkie de Jong', country: 'paises_bajos' },
      { value: 'lamine yamal', label: 'Lamine Yamal', country: 'espana' },
      { value: 'pedri', label: 'Pedri', country: 'espana' }
    ]
  },
  {
    value: 'real madrid',
    label: 'Real Madrid',
    players: [
      { value: 'federico valverde', label: 'Federico Valverde', country: 'uruguay' },
      { value: 'jude bellingham', label: 'Jude Bellingham', country: 'inglaterra' },
      { value: 'kylian mbappe', label: 'Kylian Mbappé', country: 'francia' },
      { value: 'vinicius junior', label: 'Vinícius Júnior', country: 'brasil' }
    ]
  },
  {
    value: 'atletico de madrid',
    label: 'Atletico de Madrid',
    players: [
      { value: 'antoine griezmann', label: 'Antoine Griezmann', country: 'francia' },
      { value: 'jan oblak', label: 'Jan Oblak', country: 'eslovenia' },
      { value: 'koke resurreccion', label: 'Koke Resurrección', country: 'espana' },
      { value: 'julian alvarez', label: 'Julián Alvarez', country: 'argentina' }
    ]
  }
];
